import React, {ReactElement, ReactNode} from "react";
import {useSelector} from "react-redux";
import {selectUser} from "store/auth/selectors";
import {useMaintenanceModeStore} from "store/general/maintenanceMode.store";
import MaintenanceMode from "view/apps/MaintenanceMode";

// `Apps` only swaps the whole router for the maintenance screen once a
// non-admin role is known, so routes reachable without a session need their
// own gate. The role is still unknown for anonymous visitors, so only a
// confirmed admin passes through.
const MaintenanceRoute = ({children}: {children: ReactNode}): ReactElement => {
  const {role} = useSelector(selectUser);
  const isEnabled = useMaintenanceModeStore(
    (state) => state.maintenanceMode?.enabled
  );

  if (isEnabled && role !== "admin") {
    return <MaintenanceMode />;
  }

  return <>{children}</>;
};

export default MaintenanceRoute;
